import React, { useEffect, useState } from "react";
import { bookDemoListApi } from "../../api/request/bookDemo";
import toast from "react-hot-toast";
import moment from "moment";
import SkeletonTable from "../../components/table/SkeletonTable";
import bookDemoColumns from "../../columns/BookDemoRequest/BookDemoRequest.js";
import Plus from "../../assets/Plus.jsx";

const BookDemoRequest = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const bookDemoList = async () => {
    try {
      setIsLoading(true);
      const { data } = await bookDemoListApi();
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            created_at: item?.created_at
              ? moment(item?.created_at).format("lll")
              : "--",
            date: item?.date ? moment(item?.date).format("lll") : "--",
          };
        }),
      );
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    bookDemoList();
  }, []);

  return (
    <>
      <div className="border bg-white rounded-xl py-3">
        <div className="flex items-center justify-between px-4 py-2 sm:px-4 max-sm:px-2 mb-1">
          <h2 className="text-xl font-semibold">Book Demo Requests</h2>
          {/* <button
            className="flex items-center gap-2 m-2 px-4 py-2 bg-secondary text-white rounded-md max-sm:px-1 max-sm:py-1"
            onClick={openAddModal}
          >
            <Plus className="w-5 h-5" />
            <span className="max-sm:text-xs">Add Book Demo Request</span>
          </button> */}
        </div>

        <SkeletonTable
          columns={bookDemoColumns}
          data={data}
          isLoading={isLoading}
          pagination={true}
        />
      </div>
    </>
  );
};

export default BookDemoRequest;
